import * as React from "react"
import { Box } from "@mui/material"
import { AmchartSeeker, ModalSeeker, TreemapAmchartSeeker } from "@ui-seeker/core"

import { useShareOfSearchStatusScoreMapData } from "./@hooks"


export default function ShareOfSearchStatusScoreMapChart() {

    const { dataScore, keywordName, isLoadingDataScore, resetScoreData } = useShareOfSearchStatusScoreMapData()

    if (!dataScore?.length || isLoadingDataScore) return <></>


    return <ModalSeeker
        hideActions
        isOpen={!!dataScore?.length}
        title={`Score in All Retailers for Keyword - ${keywordName}`}
        controller={() => resetScoreData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <TreemapAmchartSeeker
            data={dataScore}
            chartProps={{
                TreemapProps:{
                    rootName: 'Keyword Scores in Retailers',
                    showMainTitle: true
                }
            }}
        />
    </ModalSeeker>
}